/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_RestoreInputs */

const en_us2_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommend again`)
};

const pt_br2_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a recomendar`)
};

const es_419_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a recomendar`)
};

const pt_pt2_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar a recomendar`)
};

const fr_fr2_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommander à nouveau`)
};

const de_de2_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wieder empfehlen`)
};

const it_it2_profile_restore = /** @type {(inputs: Profile_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consiglia di nuovo`)
};

/**
* | output |
* | --- |
* | "Recommend again" |
*
* @param {Profile_RestoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_restore = /** @type {((inputs?: Profile_RestoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_RestoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_restore(inputs)
	if (locale === "es-419") return es_419_profile_restore(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_restore(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_restore(inputs)
	if (locale === "de-DE") return de_de2_profile_restore(inputs)
	if (locale === "it-IT") return it_it2_profile_restore(inputs)
	return en_us2_profile_restore(inputs)
});
export { profile_restore as "profile.restore" }